import { render, staticRenderFns } from "./IngredientItem.vue?vue&type=template&id=2799ca54&scoped=true"
import script from "./IngredientItem.vue?vue&type=script&lang=js"
export * from "./IngredientItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799ca54",
  null
  
)

export default component.exports